import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, switchMap, take, filter } from 'rxjs';
import { AuthService } from 'capiche-auth';
import { CapicheLoggerService } from 'capiche-logger';
import { CapicheSubscriptionService } from '../services/capiche-subscription.service';

export const authAndSubscriptionGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const subscriptionService = inject(CapicheSubscriptionService);
  const logger = new CapicheLoggerService('auth-subscription.guard:', false);

  return authService.authState$.pipe(
    take(1),
    switchMap((user) => {
      logger.log('authState$ user:', user);
      if (!user) {
        logger.log('authState$ no user: redirecting to /auth');
        return [router.createUrlTree(['/auth'])];
      }

      return subscriptionService.hasActiveSubscription$.pipe(
        filter((hasSub): hasSub is boolean => hasSub !== null), // wait until subscription is known
        take(1),
        map((hasSub) => {
          logger.log(user, 'hasActiveSubscription$', hasSub);
          if (hasSub) return true;
          logger.log('hasActiveSubscription$ no subscription: redirecting to /subscribe');
          return router.createUrlTree(['/subscribe']);
        }),
      );
    }),
  );
};
